import React, { lazy } from 'react'

const LibraryPage = lazy(() => import('./LibraryPage'))

export { LibraryPage }
